import { IconAsterisk } from '@loadsmart/icons'
import { toCapitalizeFirstLetter } from '@loadsmart/utils-string'

import { REQUIREMENTS } from 'legacy/constants/requirements'

function getLabelForUnknownRequirements(requirementType) {
  return toCapitalizeFirstLetter(requirementType.replace('_', ' '))
}

/**
 * Get Requirement Icon and Label
 * @param {{ type: string, params: any}} loadRequirement - Load requirement
 * @returns {{icon: any, label: string}} Object with an icon and label
 */
function getRequirementIconAndLabel(loadRequirement) {
  const requirement = REQUIREMENTS[loadRequirement.type]
  const icon = requirement ? requirement.icon : <IconAsterisk />
  let label = requirement ? requirement.label : getLabelForUnknownRequirements(loadRequirement.type)

  if (loadRequirement.type === 'tarp') {
    const tarp = loadRequirement.params
    const tarpSize = tarp.size ? `${tarp.size}'` : ''
    const tarpTypeLabel = tarp.type ? `${toCapitalizeFirstLetter(tarp.type)}` : ''
    label += ` (${tarpSize} ${tarpTypeLabel})`
  }

  return { icon, label }
}

export { getRequirementIconAndLabel }
